"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const graph_component_1 = tslib_1.__importDefault(require("../../../../../layouts/graph-component"));
const style_1 = tslib_1.__importDefault(require("../../../../../utils/style"));
function ModelTuningRCAMSStep2(props) {
    const { checkedModelDetails, saveCheckedModel, isModelSaved, decreaseStep } = props;
    const graphPath = react_redux_1.useSelector((state) => state.graph_path);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        console.log("ModelTuningStep 2", graphPath.graph_path);
    }, [graphPath]);
    return (react_1.default.createElement(core_1.Grid, { container: true },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 10, md: 8, lg: 8, style: { backgroundColor: 'white' } },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, component: "span", style: { padding: "20px 0px", display: "flex", justifyContent: "center" } }, "Save the current model within the project, train a new model, and review all the saved models."),
            react_1.default.createElement("br", null)),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 10, md: 8, lg: 8, style: { backgroundColor: 'white' } },
            react_1.default.createElement(core_1.Box, { border: 1, className: styleLocal.graphContainer },
                react_1.default.createElement(core_1.Typography, { variant: "h6", align: "center", gutterBottom: true }, "Casual Graph with Arrow Adjustment"),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 12, className: styleLocal.graph },
                    react_1.default.createElement(graph_component_1.default, { csvPath: graphPath.graph_path })))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 })));
}
exports.ModelTuningRCAMSStep2 = ModelTuningRCAMSStep2;
//# sourceMappingURL=model-tunning-step-rcams-2.js.map